// Como logo. Inline SVG painted with currentColor so it follows the theme.
// Source masters live in public/brand/.

const MARK_PATHS = (
  <>
    <path d="M209.95 184.03 A104 104 0 1 1 209.95 55.97 L171.73 85.83 A55.5 55.5 0 1 0 171.73 154.17 Z" />
    <circle cx="200.8" cy="120" r="22.5" />
    <path d="M24 240 L48 168 L112 216 Z" />
  </>
);

const MARK_SMALL_PATHS = (
  <>
    <path d="M202.81 192.24 A104 104 0 1 1 202.81 47.76 L165.41 83.88 A52 52 0 1 0 165.41 156.12 Z" />
    <circle cx="206" cy="120" r="28" />
    <path d="M20 242 L44 164 L116 218 Z" />
  </>
);

// Icon only. Pass `small` below ~32 px to use the simplified cut.
export function LogoMark({ small = false, className = "", ...rest }) {
  return (
    <svg viewBox="0 0 256 256" fill="currentColor" role="img" aria-label="Como" className={className} {...rest}>
      {small ? MARK_SMALL_PATHS : MARK_PATHS}
    </svg>
  );
}

// Full wordmark (the C is the icon). Cropped to the artwork; size with a height class.
export function Wordmark({ className = "", ...rest }) {
  return (
    <svg viewBox="0 64 588 138" fill="currentColor" role="img" aria-label="Como" className={className} {...rest}>
      <g transform="translate(-13.846 58.769) scale(.57692)">{MARK_PATHS}</g>
      <path fillRule="evenodd" d="M128 128a60 60 0 1 0 120 0a60 60 0 1 0 -120 0ZM156 128a32 32 0 1 0 64 0a32 32 0 1 0 -64 0Z" />
      <path d="M268 188V120A52 52 0 0 1 358 84.5A52 52 0 0 1 448 120V146H420V120A24 24 0 0 0 372 120V188H344V120A24 24 0 0 0 296 120V188Z" />
      <circle cx="434" cy="174" r="14" />
      <path fillRule="evenodd" d="M468 128a60 60 0 1 0 120 0a60 60 0 1 0 -120 0ZM496 128a32 32 0 1 0 64 0a32 32 0 1 0 -64 0Z" />
    </svg>
  );
}
